export default {
  settings: {
    action: {
      clear: {
        notes:
          'Clear button label for cone crusher service interval start date',
        message: 'Clear',
      },
    },
    confirmClearDialog: {
      title: {
        notes:
          'Clear dialog title for cone crusher service interval start date',
        message: 'Clear service interval start date',
      },
      content: {
        notes:
          'Clear dialog content for cone crusher service interval start date',
        message:
          'Are you sure you want to clear the service interval start date',
      },
    },
    confirmResetDialog: {
      title: {
        notes: 'Reset dialog title for cone crusher service interval',
        message: 'Reset service interval',
      },
      content: {
        notes: 'Reset dialog content for cone crusher service interval',
        message: 'Are you sure you want to reset the service interval counter?',
      },
    },
    model: {
      serviceIntervalStartDate: {
        notes: 'Label for service interval start date for a cone crusher',
        message: 'Service interval start date',
      },
      loadedHoursOnServiceIntervalStart: {
        notes:
          'Label for loaded hours at service interval start for a cone crusher',
        message: 'Loaded hours on interval start',
      },
    },
  },
};
